module.exports = __webpack_public_path__ + "img/mac.d0e94169.png";